<div id="vod-display-interactive-form" class="container cl-form" [formGroup]="poFormGroup">
  <div class="row cl-spacing-small">
    <div class="col-3">
      <label for="airline" class="form-label">Airline</label>
      <select id="airline" class="form-select" formControlName="airline" [class.invalid]="poFormGroup.controls.airline.invalid && (poFormGroup.controls.airline.touched || poFormGroup.controls.airline.dirty)">
        <option [value]="null" disabled selected>[None selected yet]</option>
        @for (airline of airlines(); track airline.iata_code) {
          <option [value]="airline.iata_code">{{ airline.airline_name }} ({{ airline.iata_code }})</option>
        }
      </select>
      @if (poFormGroup.controls.airline.errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (!poFormGroup.controls.airline.errors) {
        <p class="valid-feedback">The airline this cycle is for.</p>
      }
    </div>

    <div class="col-3">
      <label for="supplier" class="form-label">Content Supplier</label>
      <input id="supplier" type="text" formControlName="supplier" pattern="[a-z0-9\-]+" [class.invalid]="poFormGroup.controls.supplier.invalid && (poFormGroup.controls.supplier.touched || poFormGroup.controls.supplier.dirty)">
      @if (poFormGroup.controls.supplier.errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (poFormGroup.controls.supplier.errors?.pattern) {
        <p class="invalid-feedback">Lowercase letters, numbers and '-' only — no '_'.</p>
      }
      @if (!poFormGroup.controls.supplier.errors) {
        <p class="valid-feedback">Who delivers this content. Grants that supplier sight of the order.</p>
      }
    </div>

    <div class="col-3">
      <label for="projectid" class="form-label">Project ID</label>
      <input id="projectid" type="text" formControlName="po_number" pattern="[A-Za-z0-9_\.\-\/]+" [class.invalid]="poFormGroup.controls.po_number.invalid && (poFormGroup.controls.po_number.touched || poFormGroup.controls.po_number.dirty)">
      @if (poFormGroup.controls.po_number.errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (poFormGroup.controls.po_number.errors?.pattern) {
        <p class="invalid-feedback">Only letters, numbers and '_', '-', '/' or '.' are allowed</p>
      }
      @if (poFormGroup.controls.po_number.errors?.poNameTooLong; as tooLong) {
        <p class="invalid-feedback">The PO name "{{ tooLong.poName }}" has {{ tooLong.actual }}
          characters; the encoder accepts at most {{ tooLong.max }}.</p>
      }
      @if (poFormGroup.controls.po_number.errors?.s3TagValueTooLong; as tooLong) {
        <p class="invalid-feedback">The PO name is too long: it encodes to {{ tooLong.encoded }} of at
          most {{ tooLong.max }} characters. Characters outside <code>A-Z a-z 0-9 + - = . _ :</code>
          need three characters each when encoded.</p>
      }
      @if (!poFormGroup.controls.po_number.errors) {
        <p class="valid-feedback">The Project ID groups related encodes for easier reference and organization.</p>
      }
    </div>

    <div class="col-3">
      <label for="po_destination" class="form-label">Delivery Destination</label>
      <select id="po_destination" class="form-select" formControlName="po_destination">
        @for (dest of poDestinations; track dest.id) {
          <option [value]="dest.id">{{ dest.label }}</option>
        }
      </select>
    </div>

    <div class="col-3 ">
      <label for="auto_publish" class="form-label">Publication</label>
      <select id="auto_publish" class="form-select" formControlName="auto_publish">
        <option [value]="true"> Automatic Publication
        </option>
        <option [value]="false"> Manual Publication
        </option>
      </select>
      <p class="valid-feedback">Manual Publication allows for a final QA step before distributing the content, whereas Automatic Publication releases the content immediately upon readiness.</p>
    </div>
  </div>

  <!-- The order name is assembled from the three fields above, and each part carries meaning: the
       workflow reads the airline from the first, and the supplier is granted sight of exactly those
       orders whose second part is its own name. Shown here because a mistyped supplier name yields an
       order that supplier cannot see, with nothing on either side to explain why. -->
  @if (poName) {
    <div class="row cl-spacing-small">
      <div class="col-12">
        <p class="cl-p-small">Order name: <span class="cl-font-monospace">{{ poName }}</span></p>
      </div>
    </div>
  }

  <div class="row cl-spacing-small">
    <div class="col-12">
      @if (poItems.controls.length > 0) {
        <h2>PO Items</h2>
      }
    </div>
  </div>
  <ng-container formArrayName="poItems">

    @for (item of poItems.controls ; track poItemTrackBy(idx, item); let idx = $index) {
      <ng-container [formGroup]="poItems.controls[idx]" [formGroupName]="idx">
        <div class="row cl-spacing-small">
          <div class="col-12">
            <h3 [class.warn]="poItems.controls[idx].invalid">{{ poItems.controls[idx].value['basics']['po_item_id'] }}<button class="cl-a-quickaction" (click)="poService.removePOItem(poItems.controls[idx].value['id'])">Remove</button></h3>
          </div>
        </div>
        <input id="idinput" type="hidden" formControlName="id">
        <app-basic-poitem-vod-info formControlName="basics" [submitted]="submitted" poItemIdLabel="Title" poItemIdHelp="Used as the content ID for DRM requests."></app-basic-poitem-vod-info>
        @if (poItems.controls[idx].get('basics').errors?.titleTooLong) {
          <p class="invalid-feedback d-block">Title must be 212 characters or fewer.</p>
        }
        @if (poItems.controls[idx].get('basics').errors?.titleForbiddenChars) {
          <p class="invalid-feedback d-block">Title cannot contain ':', '%', '/', or '_'.</p>
        }
        <app-vod-display-interactive-format-specific formControlName="format_specific_data"></app-vod-display-interactive-format-specific>
        @if (poItems.controls[idx].errors?.encryptionRequiresTitle) {
          <p class="invalid-feedback d-block">Title is required when Encryption is enabled.</p>
        }
        <div class="row">
          <div class="col-12">
            <hr class="cl-spacing-small">
          </div>
        </div>
      </ng-container>
    }

  </ng-container>
  <div class="row">
    <div class="col-12">
      <app-form-footer label="Start encode" icon="play" (action)="submit_po($event)"></app-form-footer>
    </div>
  </div>

</div>
